import * as React from 'react';

export interface Props {
  key: React.Key;
  organisation_user: any;
}

export default ({ organisation_user: { user: { first_name, last_name }, date } }: Props ) => (
    <tr>
        <td scope="row">{first_name} {last_name}</td>
        <td>{date}</td>
    </tr>
);



// WEBPACK FOOTER //
// ./src/components/UserListCell.tsx